<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.farm_administrative') }}
    </p>
    <hr />
    <div class="row" v-for="(_, index) in model.nManagementRoles" :key="index">
      <select-component
        :dataOptions="getManagementRolesOptions(index)"
        :initialSelection="model.mgmt_roles[index]"
        :isMultiple="false"
        :indexSelect="index"
        :labelSelect="`${$t('common_words.administrative_role')}: `"
        :rowClass="'col-6'"
        :requireClass="'required-mgmt-roles'"
        @onChange="onInputChange"
        @onClear="model.mgmt_roles[index] = null"
        modelName="mgmt-roles"
      />
      <select-component
        :dataOptions="users"
        :initialSelection="model.mgmt_users[index]"
        :indexSelect="index"
        :labelSelect="`${$t('common_words.associated_users2')}: `"
        :rowClass="'col-4'"
        :requireClass="'required-mgmt-users'"
        @onChange="onInputChange"
        @onClear="model.mgmt_users[index] = []"
        modelName="mgmt-users"
      />

      <!-- Botones de acción por fila -->
      <div
        class="col-1 mt-3 col-sm-4 col-lg-1 d-flex justify-content-center align-items-center"
      >
        <div class="btn-group" role="group">
          <button
            class="btn btn-danger custom-shadow-btn mr-2"
            @click="handleMinus(index)"
          >
            <em class="fa fa-minus"></em>
          </button>
          <button
            v-if="index === model.nManagementRoles - 1"
            class="btn btn-success custom-shadow-btn"
            @click="handlePlus()"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      users: null,
      managementRoles: null,
      model: {
        nManagementRoles: 1,
        mgmt_roles: [],
        mgmt_users: [],
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  computed: {},

  methods: {
    /** Excluye los Roles ya usados en otras filas */
    getManagementRolesOptions(rowIndex) {
      const selectedIds = (this.model.mgmt_roles || []).filter(
        (id, i) => id != null && i !== rowIndex
      );

      return (this.managementRoles || []).filter((role) => {
        if (this.model.mgmt_roles[rowIndex] === role.id) return true;

        return !selectedIds.includes(role.id);
      });
    },

    /** Maneja cambios en los inputs dinámicos del formulario. */
    onInputChange(data) {
      try {
        switch (data.name) {
          case 'mgmt-roles':
            if (Array.isArray(this.model.mgmt_roles)) {
              this.$set(this.model.mgmt_roles, data.index, data.selects);

              this.$set(this.model.mgmt_users, data.index, []);
            }

            break;
          case 'mgmt-users':
            if (Array.isArray(this.model.mgmt_users)) {
              this.$set(this.model.mgmt_users, data.index, data.selects);
            }

            break;
          default:
            this.$set(this, data.name, data.selects);

            break;
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', {
            ...this.model,
            mgmtRolesSelected: this.model.mgmt_roles
              ? this.getNameSelected(
                  this.model.mgmt_roles,
                  this.managementRoles
                )
              : null,
            mgmtRolesUsersSelected: this.model.mgmt_users
              ? this.getAllMgmtUserSelected(this.model.mgmt_users, this.users)
              : null,
          });
        })
        .then(() => {
          for (let i = 0; i < this.model.nManagementRoles; i++) {
            if (
              isset(this.model.mgmt_users[i]) &&
              !isset(this.model.mgmt_roles[i])
            ) {
              return this.validationInputsRequired('mgmt-roles');
            } else if (
              isset(this.model.mgmt_roles[i]) &&
              !isset(this.model.mgmt_users[i])
            ) {
              return this.validationInputsRequired(
                'mgmt-users',
                false,
                false,
                true
              );
            }
          }

          return true;
        });
    },

    handleMinus(index) {
      if (this.model.nManagementRoles === 1) {
        this.model.mgmt_roles = [];
        this.model.mgmt_users = [];
      } else if (this.model.nManagementRoles > 1) {
        this.model.nManagementRoles--;
        const fieldsToRemove = ['mgmt_roles', 'mgmt_users'];

        fieldsToRemove.forEach((field) => {
          this.removeArrayItem(this.model, field, index);
        });
      }
    },

    handlePlus() {
      const selectedCount = (this.model.mgmt_roles || []).filter(
        (x) => x != null
      ).length;
      if (selectedCount < (this.managementRoles || []).length) {
        this.model.nManagementRoles++;
        this.model.mgmt_roles.push(null);
        this.model.mgmt_users.push([]);
      }
    },

    getAllMgmtUserSelected(model, origin) {
      const res = model
        .slice(0, this.model.nManagementRoles)
        .map((selectedModel, index) => {
          return this.getNameSelected(selectedModel, origin);
        });

      return res;
    },

    handleEditForm(editForm) {
      const management_roles = editForm.management_roles || [];

      // Se Limpian los arrays
      this.model.mgmt_roles = [];
      this.model.mgmt_users = [];

      management_roles.forEach((element, rowIndex) => {
        this.$set(this.model.mgmt_roles, rowIndex, element.id);

        // Convertir el objeto de usuarios en un array de IDs
        const userIds = Object.keys(element.users || {}).map((id) =>
          parseInt(id, 10)
        );
        this.$set(this.model.mgmt_users, rowIndex, userIds);
      });

      this.model.nManagementRoles = Math.max(1, this.model.mgmt_roles.length);
    },
  },

  created() {
    this.showHideLoading(true);
    Promise.all([
      Axios.getMasters('users/indexfield'),
      Axios.getMasters('managementroles'),
    ])
      .then(([usersResponse, farmsMgmtRolesResponse]) => {
        this.users = this.concatAll(usersResponse.data.data);
        this.managementRoles = farmsMgmtRolesResponse.data.data;

        if (this.isUpdate() && sessionStorage.getItem('editForm')) {
          this.handleEditForm(JSON.parse(sessionStorage.getItem('editForm')));
        }

        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        SweetAlert.warning(error.response.data.message);
      });
  },
};
</script>
